import React, { useState } from 'react';
import * as S from './styles.ts';
import {
  DynamicIcon,
  H3,
  IconBulletPoint,
  P,
  UniversalLink,
} from '@template/components';
import Image, { ImageProps } from '@template/components/Image';

export type TTabMenuItem = {
  title: string;
  icon?: string;
  subtitle: string;
  bullets: { copy: string; href?: string }[];
  image?: ImageProps;
};

export interface ITabComponentProps {
  tabs: TTabMenuItem[];
}

const TabMenu = ({ tabs }: ITabComponentProps) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index: number) => {
    if (index >= 0 && index < tabs.length) {
      setActiveTab(index);
    }
  };

  return (
    <S.Wrapper>
      <S.TabMenu>
        {tabs.map((tab, index) => {
          return (
            <S.TabMenuItem
              key={`tab-menu-${index}`}
              $active={index === activeTab}
              onClick={() => handleTabClick(index)}
              data-is-active={index === activeTab}
            >
              <DynamicIcon name={tab.icon} />
              {tab.title}
            </S.TabMenuItem>
          );
        })}
      </S.TabMenu>
      <S.TabContainer>
        {tabs.map((tab, index) => (
          <React.Fragment key={index}>
            {tab.image?.src && (
              <S.TabImageContainer
                $active={index === activeTab}
                key={`tab-image-${index}`}
              >
                <Image
                  src={tab.image?.src}
                  alt={tab.image?.alt}
                  style={{
                    objectFit: 'contain',
                  }}
                  width={800}
                  height={500}
                />
              </S.TabImageContainer>
            )}
            <S.TabContent
              $active={index === activeTab}
              key={`tab-content-${index}`}
            >
              <H3>{tab.title}</H3>
              <P>{tab.subtitle}</P>
              {tab.bullets?.map((bullet, i) => {
                return bullet.href ? (
                  <UniversalLink
                    key={`tab-${index}-bullet-${i}`}
                    href={bullet.href}
                  >
                    <IconBulletPoint
                      item={{
                        label: bullet.copy,
                        iconName: 'Check',
                      }}
                    />
                  </UniversalLink>
                ) : (
                  <IconBulletPoint
                    key={`tab-${index}-bullet-${i}`}
                    item={{
                      label: bullet.copy,
                      iconName: 'Check',
                    }}
                  />
                );
              })}
            </S.TabContent>
          </React.Fragment>
        ))}
      </S.TabContainer>
    </S.Wrapper>
  );
};

export default TabMenu;
